// reusable cookies functionality
(function () {
  /* eslint-disable */
  RS.Utils.LocalStorage = {

    expiresInDays: 30,

    isExpired: function (lastUpdateInMs) {
      var _diffdays = Math.ceil(Math.abs(new Date().getTime() - lastUpdateInMs) / 86400000);
      return (_diffdays > this.expiresInDays);
    },

    isAvailable: function () {
      var _storage;
      var _result;
      try {
        _storage = localStorage.setItem('uid', 'uid');
        _result = localStorage.getItem('uid') === 'uid';
        localStorage.removeItem('uid');
        return _result;
      } catch (e) {
        return false;
      }
    },

    isSessionStorageAvailable: function () {
      var _storage;
      var _result;
      try {
        _storage = sessionStorage.setItem('uid', 'uid');
        _result = sessionStorage.getItem('uid') === 'uid';
        sessionStorage.removeItem('uid');
        return _result;
      } catch (e) {
        return false;
      }
    },

    getItemFromSessionStorage: function (cname) {
      return this.isSessionStorageAvailable() ? sessionStorage.getItem(cname) : null;
    },

    getItem: function (cname) {
      return (this.isAvailable() && !this.isExpired()) ? localStorage.getItem(cname) : null;
    },

    getItemWithoutExpiry: function (cname) {
      return this.isAvailable() ? localStorage.getItem(cname) : null;
    },

    setItem: function (cname, objData) {
      if (RS.Utils.LocalStorage.isAvailable()) {
        localStorage.setItem(cname, objData);
      }
    },

    setItemInSessionStorage: function (cname, objData) {
      if (RS.Utils.LocalStorage.isSessionStorageAvailable()) {
        sessionStorage.setItem(cname, objData);
      }
    },
  };
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/utils/localstorage.js
// module id = 319
// module chunks = 4